import DirectMessageAttachmentsPage from './DirectMessageAttachmentsPage'

export default DirectMessageAttachmentsPage
